import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'

Vue.component('apexcharts', VueApexCharts)
